<template>
    <div v-if="!pending" class="layout-contents" data-wing-expand>
        <!-- 미검사 정책 -->
        <div v-if=" getComplianceStatus == null && !doingInspection" class="compliance-unexamined">
            {{ $t('COMPLIANCE.RESULT.NEVER_RUN_EVALUATION_1') }}<!--정책 검사를 한번도 하지 않았습니다.--> <br>
            {{ $t('COMPLIANCE.RESULT.NEVER_RUN_EVALUATION_2') }} <!--버튼을 눌러 검사를 진행해 주세요.--><br>
            <button class="buttons" data-size="s"
                    type="button"
                    v-on:click="callDoComplianceDetailV1">
                {{ $t('COMPLIANCE.BUTTON.EVALUATE') }}
            </button>
        </div>
        <!-- 검사중 -->
        <div v-else-if="(getComplianceStatus === 'R' || doingInspection)" class="compliance-unexamined">
            <div class="loading">
                <span>
                {{ $t('COMPLIANCE.RESULT.NOW_EVALUATING') }}
                </span>
            </div>
        </div>
        <!-- 검사 결과가 있을 때 -->
        <div v-else class="compliance-result-summary">
            <table class="tbl-basic-info">
                <caption> {{ $t('COMPLIANCE.RESULT.SUMMARY') }}</caption>
                <colgroup>
                    <col style="width: 200px;">
                    <col>
                </colgroup>
                <tbody>
                    <tr>
                        <th scope="row">
                            <label>{{ $t('COMPLIANCE.LABEL.LAST_EVALUATION') }}<!--최근 검사--></label>
                        </th>
                        <td>
                            <div class="assessment-btn-group">
                                <div class="time-title">
                                    <span>
                                        <label>
                                            <time>
                                                {{
                                                    getComplianceStatus != null ? getComplanceExecuteDate : $t('COMPLIANCE.RESULT.NEVER_RUN_EVALUATION_0')
                                                }}
                                            </time>
                                        </label>
                                    </span>
                                    <span v-if="getComplianceStatus">
                                        <label>{{ getComplanceExecuteUser }}</label>
                                    </span>
                                </div>
                                <div class="btn-assessment">
                                    <button v-if="getComplianceStatus != null && getMenuAuth === constants.AUTH_TYPE.EDIT && isLog != true"
                                          class="buttons" data-size="s"
                                          type="button"
                                          v-on:click="callDoComplianceDetailV1">{{ $t('COMPLIANCE.BUTTON.RE_EVALUATION') }}
                                    <!--재검사--></button>
                                </div>

                            </div>
                        </td>
                    </tr>
                        <tr>
                        <th scope="row">
                            <label>{{ $t('COMPLIANCE.LABEL.SCOPE_OF_LAST_EVALUATION') }}</label>
                        </th>
                        <td>
                            <div>
                                <div class="toggle-accounts">
                                    <div v-if="cmplDetail.acntList != null && cmplDetail.acntList.length > 0"
                                        :data-expand="isAccuntOpen ? true : null"
                                        class="accounts">
                                        <span v-for="(acc, index) of cmplDetail.acntList" :key="index"
                                            :title="acc.delYn === 'Y' ? $t('COMPLIANCE.DETAIL.DELETED_ACCOUNT') : ''"
                                            class="icon-tag"
                                            data-type="account" v-bind:data-deleted="acc.delYn === 'Y' ? true : null">
                                            <span :data-vendor="Common.getVendorByKey(acc.vendor)" class="icon-vender" data-size="s"></span>
                                            {{ acc.accId }}({{ acc.accAlias }})
                                        </span>
                                    </div>
                                    <div v-else>
                                        {{ $t('COMPLIANCE.RESULT.NONE_ACCOUNT') }}
                                    </div>
                                    <button v-if="isAccountView" type="button" class="txt-status btn-toggle-accounts" data-status="key" v-on:click="openAccountSection()">
                                        <span class="expand"> {{$t('COMPLIANCE.DETAIL.EA_MORE', {cnt : remainerCnt})}}</span>
                                        <span class="collapse">{{ $t('COMMON.BUTTON.CAMEL.COLLAPSE')}}<!--접기--></span>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- chart 영역-->
        <div v-if="cmplDetail.rsltId != null && getComplianceStatus !== 'R' && !doingInspection"
             class="compliance-detail-hstack">
            <!-- 검사 점수 -->
            <TabResultScore
                :activeFail="getComplianceStatus"
                :cData="getFailRuleBySeverityData"
                :locale="getLocale"
            />
            <!-- 지역별 검사 상태 -->
            <TabResultState
                v-bind:active-fail="getComplianceStatus"
                v-bind:cmplId="cmplDetail.cmplId"
                :locale="getLocale"
                :ruleIdentify="getRuleIdentify"
                :curCmpnId="curCmpnId"
                :failedRulesList="failedRulesList"
                :pending="pendingState"
            />
        </div>
        <!--적용된 규칙-->
        <div class="box-container">
            <div class="box-container-header">
                <h3 class="box-title">{{ $t('COMPLIANCE.LABEL.APPLIED_RULES') }}<!--적용된 규칙--> </h3>
            </div>
            <fieldset class="tbl-filters">
                <legend>table filters</legend>
                <div :key="getLocale" class="seperate">
                    <select-box-multi
                        :select-box-options="cmplDetail.ctgLabelFilterData"
                        place-holder="FILTER.SELECT_CATEGORY"
                        select-class="type-checkbox"
                        select-id="select_ctg"
                        @onSelectChange="callSetSearchKey('searchCtg',$event.value)"/>
                    <select-box-multi
                        :select-box-options="cmplDetail.prodFilterData"
                        place-holder="FILTER.SELECT_PRODUCT"
                        select-class="type-checkbox"
                        select-id="select_prod"
                        @onSelectChange="callSetSearchKey('searchProd',$event.value)"/>
                </div>
                <div class="search-box">
                    <input v-model="searchText"
                        class="pr-0" type="search"
                        v-bind:placeholder="$t('COMMON.SEARCH.ENTER_SEARCH')"
                        @keyup="callSetSearchKey('searchTxt', searchText)">
                    <button v-show="searchText !== ''" class="buttons-icon" data-icon="clear" data-size="s"
                            data-type="ghost" type="button" v-on:click="clearSearchText(searchText)">Reset
                    </button>
                    <button class="btn-search" type="button" v-on:click="callSetSearchKey"></button>
                </div>
            </fieldset>
            <!--rule list-->
            <div-loading v-if="isLoading" :full="true"></div-loading>
            <table class="tbl-default" data-linkable-row>
                <caption></caption>
                <colgroup>
                    <col style="width: 125px;">
                    <col ref="columnRuleName">
                    <col>
                    <col style="width: 140px;">
                    <col style="width: 125px;">
                </colgroup>
                <thead>
                <tr>
                    <th scope="row">
                        <button class="buttons-tbl-header" data-tooltip-content="#tooltip-stat-filter"
                                data-type="filter"
                                type="button">{{ $t('LABEL.EVAL_STAT') }}
                            <!--검사 상태--></button>
                        <div class="tooltip_templates">
                            <div id="tooltip-stat-filter">
                                <ul class="list-filter">
                                    <li v-for="(stat, index) of constants.COMPLIANCE_STAT_FILTER" :key="index">
                                        <input :id="stat.key" :value="stat.key" class="checkbox" name="filter-type" type="checkbox" v-model="cmplStatFilter">
                                        <label :for="stat.key">{{ $t(stat.val) }}</label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </th>
                    <th scope="row">
                        <button class="buttons-tbl-header" type="button"
                                v-bind:data-type="sortColumn !== 'ruleTitl' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
                                v-on:click="callSetSortColumn('ruleTitl')"
                        >{{ $t('LABEL.RULE_NAME') }}<!--규칙 이름--></button>
                    </th>
                    <th scope="row">
                        <button class="buttons-tbl-header" type="button"
                                v-bind:data-type="sortColumn !== 'prodNm' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
                                v-on:click="callSetSortColumn('prodNm')"
                        >{{ $t('LABEL.PRODUCT') }}<!--제품--></button>
                    </th>
                    <th scope="row">
                        <button class="buttons-tbl-header" data-tooltip-content="#tooltip-svrty-filter"
                                data-type="filter"
                                type="button">{{ $t('LABEL.SEVERITY') }}
                            <!--심각도--></button>
                        <div class="tooltip_templates">
                            <div id="tooltip-svrty-filter">
                                <ul class="list-filter">
                                    <li v-for="(stat, index) of constants.SVRTY_FILTER" :key="index">
                                            <input :id="stat.key" :value="stat.key" class="checkbox" name="filter-type" type="checkbox" v-model="cmplSvrtyFilter">
                                            <label :for="stat.key">{{ $t(stat.val) }}</label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </th>
                    <th v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" scope="row">
                        {{ $t('COMPLIANCE.LABEL.TAKE_FOLLOWING_ACTION') }}<!--다음 작업 실행-->
                        <button :title="$t('COMPLIANCE.RESULT.ACTION_TOOLTIP')" class="buttons-icon" data-icon="info"
                                data-size="xs" data-trigger="tooltip"
                                data-type="ghost" type="button">info
                        </button>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(rule, index) of getRulesFilter"
                    :key="index"
                    v-bind:class="{'selected' : curRule != null && rule.ruleId === curRule.ruleId}"
                    v-on:click="openRuleDetail(rule, $event)">
                    <td class="txt-c cmpl-status">
                        <template v-if="rule.onEdit==null || rule.onEdit===false">
                            <span v-if="getComplianceRuleStatus(rule) == null" class="icon-tag" data-icon="unexamined"
                                  data-type="waiting">{{ $t('COMPLIANCE.EVAL_STAT.UNEXAMINED') }}<!--미검사--></span>
                            <span v-else-if="getComplianceRuleStatus(rule) === 'R'" class="icon-tag"
                                  data-icon="examining"
                                  data-type="waiting">{{ $t('COMPLIANCE.EVAL_STAT.EXAMINING') }}<!--검사중--></span>
                            <span v-else-if="getComplianceRuleStatus(rule) === 'E'" class="icon-tag" data-type="error">{{
                                    $t('COMPLIANCE.EVAL_STAT.ERROR')
                                }}
                                <!--에러--></span>
                            <span v-else-if="getComplianceRuleStatus(rule) === 'P'" class="icon-tag"
                                  data-type="success">{{ $t('COMPLIANCE.EVAL_STAT.PASSED') }}<!--패스--></span>
                            <span v-else-if="getComplianceRuleStatus(rule) === 'F'" class="icon-tag" data-type="failer">{{
                                    $t('COMPLIANCE.EVAL_STAT.FAILED')
                                }}
                                <template v-if="rule.autoExeYn==='Y'">
                                    <template
                                        v-if="rule.execYn === 'N' && rule">({{
                                            $t('COMPLIANCE.EVAL_STAT.UNSOLVED')
                                        }})</template>
                                    <template v-else> ({{ $t('COMPLIANCE.EVAL_STAT.SOLVED') }})</template>
                                </template>
                            </span>
                        </template>
                    </td>
                    <td class="cmpl-title">
                        <div v-bind:style="{maxWidth : maxWidth + 'px'}" v-if="doneLoopArray(index)">
                            <span class="mr-2" v-bind="{'indexRule' : index}"
                                :title="getRuleTitle(rule)"
                                >{{getRuleTitle(rule)}}
                            </span>
                            <span>
                                <span v-bind="{'indexRule' : index}">
                                    <span v-for="(label, index) of rule.ctgLabel" :key="index" class="icon-tag mx-1"
                                        data-type="category-label">{{ label }}</span>
                                </span>
                            </span>
                        </div>
                    </td>
                    <td class="cmpl-product">
                        <RuleProducts
                            :ruleId="rule.ruleId"
                            :cndVal="rule.cndVal"
                            :autoExeYn="rule.autoExeYn"
                            :templateList="templateList"
                        />
                    </td>
                    <td class="cmpl-severity">
                        <span class="icon-serious"
                              v-bind:data-status="rule.svrty === 1 ? 'low' : rule.svrty === 2 ? 'medium' : rule.svrty === 3 ? 'high' :'critical' ">{{
                                getSeverityLabel(rule.svrty)
                            }}</span>
                    </td>
                    <td v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" class="txt-c cmpl-action">
                        <template v-if="checkDetail(rule)">
                            <DetailButton
                                :key="rule.ruleId"
                                :rule="rule"
                                :cmpnId="curCmpnId"
                                :user="loginUser"
                                :rsltId="cmplDetail.rsltId"
                                :doneIncident="doneIncident"
                            />
                        </template>
                        <template v-else>
                          <button class="buttons" data-size="s" data-type="key" type="button"
                                  v-bind:disabled="getComplianceRuleStatus(rule) !== 'F' || rule.execYn !== 'N' || !rule.availAction ? true : null "
                                  v-on:click="execActionV1(rule); rule.availAction = false">{{ $t('COMPLIANCE.BUTTON.NEXT_ACTION') }}</button>
                        </template>
                    </td>
                </tr>
                <tr v-if="getRulesFilter.length === 0">
                    <td class="data row" colspan="5">
                        <div class="none">
                            {{ $t('POLICY.RULE.NO_APPLIED_RULE') }}
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <ComplianceSideRuleDetail
            :action-template-list="cmplDetail.actionTemplateList"
            :commonInfo="commonInfo"
            :rule="curRule"
            :ruleDetails="cmplByRule"
            :failedRulesList="failedRulesList"
            :user-list="cmplDetail.userList"
            :rsltId="cmplDetail.rsltId"
            :roleCode="roleCode"
            @executeAction="execAction($event)"
            @hideDetail="closeRuleDetail"
        />
        <aside id="toast-popup-ui add" ref="toastAction" class="layout-toast-message">
            <h2 class="title">Notification</h2>

            <p class="message">
                {{ $t('COMPLIANCE.DETAIL.ACTION_HAS_BEEN_RUN') }}
            </p>
            <button class="btn-close" type="button">{{ $t('COMPLIANCE.BUTTON.CLOSE_TOAST_MESSAGE') }}</button>
        </aside>
    </div>
    <div-loading v-else :full="true"></div-loading>
</template>

<script>
import {BCol, BRow} from "bootstrap-vue";
import ComplianceSideRuleDetail from "./complianceSideRuleDetail.vue";
import TabResultState from "./widget/TabResultState.vue";
import TabResultScore from "./widget/TabResultScore.vue";
import RuleProducts from "../../components/rule/ruleComponents/RuleProducts.vue";
import _ from "lodash";
import {mapGetters} from "vuex";
import DetailButton from './widget/DetailButton.vue'

export default {
    name: 'ComplianceDetailTabResult',
    components: {
        BRow, BCol,
        ComplianceSideRuleDetail,
        TabResultState,
        TabResultScore,
        RuleProducts,
        DetailButton
    },
    props: {
        isLog: {
            type: Boolean,
            default: false
        },
        ruleListSearch: Array,
        cmplDetail: Object,
        sortColumn: String,
        ruleListData: Array,
        pending: false,
        doingInspection: false,                // 새로운 검사 진행 상태
        callSetSearchKey: Function,
        callSetSortColumn: Function,
        callDoComplianceDetail: {
            type: Function,
            default: ()=>{}
        },
        callDoComplianceDetailV1: {
            type: Function,
            default: ()=>{}
        },
        roleCode: String
    },
    data() {
        return {
            curRule: null                                 // Information of selected rule
            , sortOrder: ''                                 // Sort order
            , cmplByRule: {},
            isAccuntOpen: false, // account section data-expand
            isAccountView: false, // account more button
            remainerCnt: 0,
            commonInfo: {},
            searchText: '',
            failedRulesList: [],
            pendingState: true,
            cmplStatFilter: this.constants.PARAM.SELECT.FILTER_ALL,
            cmplSvrtyFilter: this.constants.PARAM.SELECT.SEARCH_SEVERITY,
            maxWidth : 300,
            listRulesFilter: [],
            ruleList: _.cloneDeep(this.ruleListSearch),
            isLoading: false,
            listRuleIncident: []
        }
    },
    created: function () {
        this.initUI();
    },
    computed: {
        getMenuAuth: function () {
            //메뉴 별 권한
            let auth = _.find(this.$store.state.GOV_MENU_AUTH, {menuId: this.constants.MENU.COMPLIANCE_ASSESSMENT})
            return auth ? auth.authTypeCd : this.constants.AUTH_TYPE.NONE
        },
        ...mapGetters({
            curCmpnId: 'user/curCmpnId',
            loginUser: 'user/loginUser'
        }),
        getLocale: function () {
            return this.$i18n.locale
        },
        getComplianceStatus: function () { // compliance score chart에서 선택할 탭 정보 넘겨줌, compliance 결과를 가장 먼저 선택하도록 함
            // 기본적으로 가장 앞에 있는 성공, 성공이 없으면 실패, 실패도 없으면 에러
            let value = 'P';
            if (typeof (_.head(this.ruleListData)) !== this.constants.TYPE.UNDEFINED) {
                value = _.head(this.ruleListData).cmplStat
            }
            return value;
        },
        getComplanceExecuteDate: function () {
            let value = null;
            if (typeof (_.head(this.ruleListData)) !== this.constants.TYPE.UNDEFINED) {
                value = this.Common.convertUtcTimezoneToLocalByLang(this.ruleListData[0].execDt, this.getLocale)
            }
            return value
        },
        getComplanceExecuteUser: function () {
            let value = null;
            if (typeof (_.head(this.ruleListData)) !== this.constants.TYPE.UNDEFINED) {
                value = _.head(this.ruleListData).execId === 'Scheduled' ? 'SYSTEM' : _.head(this.ruleListData).execUserNm
            }
            return value
        },
        getFailRuleBySeverityData: function () {
          //  const ruleList = _.filter(this.ruleListData, {'autoExeYn': 'Y'});
            const ruleList = this.ruleListData;
            let pass = _.filter(ruleList, ['ruleCmplRslt', 'P']) ? _.filter(ruleList, ['ruleCmplRslt', 'P']) : 0;
            let fail = _.filter(ruleList, ['ruleCmplRslt', 'F']) ? _.filter(ruleList, ['ruleCmplRslt', 'F']) : 0;
            let error = _.filter(ruleList, ['ruleCmplRslt', 'E']) ? _.filter(ruleList, ['ruleCmplRslt', 'E']) : 0;
            // 검사 점수 계산
            let score = ((pass.length / ruleList.length) * 100).toFixed(1)
            return {
                totCnt: ruleList.length,
                score, pass, fail, error
            }
        },
        getRuleIdentify: function () {
            return this.ruleListData.map(({siteCd, cmpnId, ruleId, ruleRvsnId}) => ({
                siteCd,
                cmpnId,
                ruleId,
                ruleRvsnId
            }));
        },
        templateList: function () {
            return this.$store.state.templateList;
        },
        getRulesFilter: function() {
            this.listRulesFilter = this.ruleList.filter((p) => {
                let chkSvrtyFilter = _.isEmpty(this.cmplSvrtyFilter) || (_.size(this.cmplSvrtyFilter) === _.size(this.constants.SVRTY_FILTER))
                    || _.includes(this.cmplSvrtyFilter, p.svrty);
                let chkStatFilter = _.isEmpty(this.cmplStatFilter) || (_.size(this.cmplStatFilter) === _.size(this.constants.COMPLIANCE_STAT_FILTER))
                    || _.includes(this.cmplStatFilter, this.getCmplStatByRule(p));
                return chkSvrtyFilter && chkStatFilter;
            })
            return this.listRulesFilter;
        },
    },
    watch: {
        curCmpnId() {
            this.$router.push(`/compliance`);
        },
        getRuleIdentify() {
            this.selectFailedRuleList();
        },
        ruleListSearch() {
            this.ruleList = _.cloneDeep(this.ruleListSearch)
        }
    },
    mounted() {
        this.initUI();
        this.renderShowMoreAccountBtn();
        this.selectFailedRuleList();
        document.getElementsByClassName("selection dropdown multiple")[0].addEventListener("click", this.clickOnSlctCtg);
        document.getElementsByClassName("selection dropdown multiple")[1].addEventListener("click", this.clickOnSlctProd);
        window.addEventListener('resize', () => {
            this.maxWidth = 300;
            let _this = this;
            setTimeout(() =>{
                let maxWidth = (_this.$refs.columnRuleName || {}).clientWidth;
                _this.maxWidth = maxWidth;
            }, 100);
            ($('span[indexrule]') || []).each(function(value){
                let innerWidth = $(this).width() + 5;
                ($('div[indexrule=' + value +']') || []).attr('style', 'max-width : calc(100% - ' + innerWidth + 'px)');
            });
        });

    },
    methods: {
        getRuleTitle(rule) {
            let title = rule.ruleTitl;
            if (rule.transTitl) {
                title = rule.transTitl;
            } else if (rule.siteCd === this.constants.POLICY_TYPE.BEST_PRACTICE || rule.userDefiYn ==='N') {
                const localeTitle = _.get(rule,`${this.$i18n.locale}RuleTitle`);
                if (localeTitle) {
                    title = localeTitle;
                }
            }
            return title;
        },
        clickOnSlctProd(e) {
            this.hideMenu("select_ctg");
            const firstChildNode = _.get(e, "target.firstChild.nodeName");
            if (firstChildNode !== "SELECT") return;
            const select = document.getElementsByClassName("select_prod multiple")[0];
            const target = select.getElementsByClassName("menu transition")[0];
            if (document.getElementsByClassName("menu visible")[0]) {
                target.classList.remove("visible");
                target.classList.add("hidden");
                select.classList.remove("active");
            } else if(document.getElementsByClassName("menu hidden")[0]) {
                target.classList.remove("hidden");
                target.classList.add("visible");
            }
        },
        clickOnSlctCtg(e) {
            this.hideMenu("select_prod");
            const firstChildNode = _.get(e, "target.firstChild.nodeName");
            if (firstChildNode !== "SELECT") return;
            const select = document.getElementsByClassName("select_ctg multiple")[0];
            const target = select.getElementsByClassName("menu transition")[0];
            if (document.getElementsByClassName("menu visible")[0]) {
                target.classList.remove("visible");
                target.classList.add("hidden");

                select.classList.remove("active");
            } else if(document.getElementsByClassName("menu hidden")[0]) {
                target.classList.remove("hidden");
                target.classList.add("visible");
            }
        },
        hideMenu(targetMenu) {
            const select = document.getElementsByClassName(`${targetMenu} multiple`)[0];
            const target = select.getElementsByClassName("menu transition")[0];
            if (target) {
                target.classList.remove("visible");
                target.classList.add("hidden");
                select.classList.remove("active");
            }
        },
        async selectFailedRuleList() {
            if (this.curCmpnId && this.getRuleIdentify && this.getRuleIdentify.length > 0) {
                const url = "/api/governance/compliance/result/chart/status";
                const header = {
                    cmpnId: this.curCmpnId,
                    ruleIdentify: this.getRuleIdentify,
                    isDetailPolicyPage: true,
                };
                try {
                    this.pendingState = true;
                    const response = await this.http.post(url, JSON.stringify(header));
                    const result = _.get(response, "data.result");
                    if (result) {
                        this.failedRulesList = result;
                    }
                } catch (err) {
                    console.error("selectFailedRuleList: " + err);
                } finally {
                    this.pendingState = false;
                }
            }
        },
        renderShowMoreAccountBtn() {
            const self = this;
            let acntList = $('span[data-type=account]');
            let topPosition;
            this.remainerCnt = 0;

            $('span[data-type=account]').each(function(idx, item) {
                let currentPosition = item.getBoundingClientRect().top;
                if (topPosition && topPosition != currentPosition) {
                    self.remainerCnt = acntList.length - idx;
                    self.isAccountView = true;
                    return false;
                }
                topPosition = currentPosition;
            });
        },
        getCommonInfo: function () {
            const url = "/api/governance/compliance/common/info";
            const header = {
                cmpnId: this.curCmpnId,
                cmplId: this.cmplId,
                rsltId: this.rsltId
            }
            this.http.post(url, JSON.stringify(header))
                .then(result => {
                    this.commonInfo = result.data;
                });
        },
        initUI() {
            this.initMultiFilter()
            this.initActionTooltip();
        },
        getVendors(rule) {
            let vendors = [];
            if (this.templateList && this.templateList.length > 0) {
                for (let condition of rule.cndVal) {
                    const conditionProd = _.find(this.templateList, {'tmpltId': condition.tmpltId});
                    let vendor = _.get(conditionProd, 'vendor');
                    vendor = this.Common.getVendorByKey(vendor);
                    vendors.push(vendor)
                }
                vendors = _.uniq(vendors)
            }
            return vendors;
        },
        getProductListOfRule(rule) {
            let prodArray = [];
            if (this.templateList && this.templateList.length > 0) {
                for (let condition of rule.cndVal) {
                    let conditionProd = _.find(this.templateList, {'tmpltId': condition.tmpltId})
                    if (conditionProd) {
                        prodArray.push(conditionProd.prod)
                    }
                }
                prodArray = _.uniq(prodArray)
            }
            return prodArray
        },
        clearSearchText: function () {
            this.searchText = '';
            this.callSetSearchKey('searchTxt', '');
        },
        openRuleDetail(rule, $event) {
            if (rule.autoExeYn === 'Y' && $event.target.nodeName !== 'BUTTON') {
                let curRule = _.cloneDeep(rule);
                let idx = _.findIndex(this.listRuleIncident, function(o) { return o.ruleId == rule.ruleId; });
                if (idx !== -1) {
                    let detail = this.listRuleIncident[idx];
                    curRule.url = detail.url;
                    curRule.statusCode = detail.statusCode;
                    curRule.isDisabled = detail.isDisabled;
                }
                this.curRule = curRule;
                this.getCmplByRule(rule);
                this.getCommonInfo();
                $('body').toggleAttr('data-wing-expand', '');
            }
        },
        getCmplByRule(rule) {
            const intgId = this.$route.query.rslt;
            const url = "/api/governance/cmpl/list/detail";
            const header = {
                'cmpnId': rule.cmpnId,
                'cmplId': rule.cmplId,
                'plcyRvsnId': rule.rvsnId,
                'ruleRvsnId': rule.ruleRvsnId,
                intgId
            }
            this.http.post(url, JSON.stringify(header))
                .then(result => {
                    if (result.data) {
                        this.cmplByRule = result.data
                    }
                })
        },
        execAction: function (rule) {
            this.isLoading = true;
            let self = this
            _.find(this.ruleListData, function (o) {
                if (o.ruleId === rule.ruleId) {
                    o.execYn = self.constants.PARAM.SELECT.Y
                }
            })
            const url = "/api/governance/action/exec";
            const {cmplId, rsltId} = this.cmplDetail;
            const cmpnId = this.curCmpnId;
            const reqData = {
                cmpnId, cmplId, rsltId,
                'actn': [rule]
            }

            this.http.post(url, reqData)
                .then(response => {
                    this.ruleList.forEach(item => {
                        if (item.ruleId == rule.ruleId) {
                            rule.execYn = this.constants.PARAM.SELECT.Y;
                            return;
                        }
                    });
                    this.isLoading = false;
                    this.showActionToast()
                }).catch(error => {
                   this.isLoading = false;
                })
        },
        execActionV1: function (rule) {
            this.isLoading = true;
            let self = this
            _.find(this.ruleListData, function (o) {
                if (o.ruleId === rule.ruleId) {
                    o.execYn = self.constants.PARAM.SELECT.Y
                }
            })
            const url = "/api/governance/action/exec/v1";
            const {cmplId, rsltId} = this.cmplDetail;
            const cmpnId = this.curCmpnId;
            const reqData = {
                cmpnId, cmplId, rsltId,
                'actn': [rule]
            }

            this.http.post(url, reqData)
                .then(response => {
                    this.ruleList.forEach(item => {
                        if (item.ruleId == rule.ruleId) {
                            rule.execYn = this.constants.PARAM.SELECT.Y;
                            return;
                        }
                    });
                    this.isLoading = false;
                    this.showActionToast()
                }).catch(error => {
                this.isLoading = false;
            })
        },
        // TODO : Failed Rule 한번에 Action 실행
        execAllAction: function () {
            this.showActionToast()
        },
        showActionToast: function () {
            let self = this
            $('#toast-example .btn-close').on('click', function () {
                $('#toast-example').removeAttribute('data-show')
            })
            this.$refs.toastAction.setAttribute('data-show', true)
            setTimeout(function () {
                self.$refs.toastAction.removeAttribute('data-show')
            }, 3000)
        },
        closeRuleDetail: function () {
            this.cmplByRule = {};
            this.curRule = null;
            $('body').toggleAttr('data-wing-expand', '');
        },
        viewPopup(popupId) {
            this.Common.viewPopup(popupId)
        },
        getSeverityLabel(svrty) {
            return this.$t("LABEL.SVRTY." + svrty)
        },
        initMultiFilter: function () {
            let $filterTarget = $('.buttons-tbl-header[data-type=filter]')

            $filterTarget.tooltipster({
                animation: 'fade',
                side: 'bottom',
                theme: 'go-filter',
                interactive: true,
                trigger: 'click',
                functionBefore: function (instance, helper) {
                    $(helper.origin).addClass("selected");
                },
                functionAfter: function (instance, helper) {
                    $(helper.origin).removeClass("selected");
                },
                functionPosition: function (instance, helper, position) {
                    position.coord.top -= 7;
                    position.coord.left = helper.geo.origin.offset.right - position.size.width;
                    return position;
                }
            });
        },
        getComplianceRuleStatus: function (rule) {
            return rule.ruleCmplRslt;
        },
        initActionTooltip() {
            let target = $('[data-trigger="tooltip"]');
            target.tooltipster({
                delay: 300,
                animation: 'fade',
                updateAnimation: 'fade',
                side: 'bottom',
                arrow: true,
                contentAsHTML: true,
                interactive: true,
            });
        },
        openAccountSection() {
            this.isAccuntOpen = !this.isAccuntOpen
        },
        getCmplStatByRule: function (rule) {
            if (rule.ruleCmplRslt !== 'F') {
                return rule.ruleCmplRslt;
            }
            if (rule.autoExeYn ==='Y' && rule.execYn !== 'N') {
                return 'FS';
            }
            return 'FU';
        },
        doneLoopArray(index) {
            if(index === (this.listRulesFilter.length - 1)){
                let _this = this;
                if (this.maxWidth === 300){
                    setTimeout(() =>{
                        let maxWidth = _this.$refs.columnRuleName.clientWidth;
                        if (maxWidth !== 0) {
                            _this.maxWidth = maxWidth;
                            ($('span[indexrule]') || []).each(function(value){
                                let innerWidth = $(this).width() + 5;
                                ($('div[indexrule=' + value +']') || []).attr('style', 'max-width : calc(100% - ' + innerWidth + 'px)');
                            });
                        }
                    }, 100);
                }
            }
            return true;
        },
        checkDetail: function(rule) {
            let isIntergartion = false;
            let isFailSoveld = false;
            // check actionId is intergartion?
            (rule.actnVal || []).forEach(item => {
                if (item.actnId == 'actn_alertnow') {
                    isIntergartion = true;
                    return true;
                }
            });

            // check status is fail soveld?
            isFailSoveld = rule.ruleCmplRslt === 'F' && rule.autoExeYn === 'Y' && rule.execYn !== 'N';

            return isIntergartion && isFailSoveld;
        },
        doneIncident: function (incident) {
            this.listRuleIncident.push(incident);
        }
    }
}
</script>

<style scoped>
.data.row {
    display: table-cell;
}
.assessment-btn-group {
    width: 100%;
}
.assessment-btn-group .title {
    width: 10%;
    display: inline-block;
}

.assessment-btn-group .time-title {
    display: inline-block;
    margin-right: 8px;
}

.assessment-btn-group .btn-assessment {
    width: 20%;
    display: inline-block;
}

td.assessment-btn-group .row {
    align-items: center;
}

td.assessment-btn-group button {
    border-radius: 4px !important;
}

td.assessment-btn-group .title {
    color: #666666;
}

.tbl-default .actions {
    position: inherit;
    top: 0;
    right: 0;
    bottom: 0;
}

.segmented-control label {
    padding: 0 4px;
    border-radius: 4px;
    line-height: 24px;
}

label.fail-icon {
    color: #FF2741;
    background-color: rgba(255, 201, 211, 0.5);
    cursor: pointer;
}

label.pass-icon {
    color: #056EFF;
    background-color: rgba(173, 222, 255, 0.5);
    cursor: pointer;
}

label.unexamined-icon {
    color: #6C7994;
    background-color: rgba(211, 217, 235, 0.5);
    cursor: pointer;
}
.rule-name-column {
    align-items: center;
    white-space: nowrap;
    max-width: 300px;
    display: flex;
    flex-direction: row-reverse;
}
.rule-name-description {
    flex-basis: max-content;
    max-width: unset;
}
.rule-name-category {
    flex-grow: 1;
    margin-left: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
}
.cmpl-status {
    width: 15%;
    word-break: break-word;
}
.cmpl-title {
    width: 49%;
    word-break: break-word;
}
.cmpl-product {
    width: 15%;
    word-break: break-word;
}
.cmpl-severity {
    width: 10%;
    word-break: break-word
}
.cmpl-action {
    width: 11%;
    word-break: break-word
}
</style>




// WEBPACK FOOTER //
// src/components/compliance/complianceDetailTabResult.vue